import { css } from '@emotion/react';
import ParticipantDot from 'athena/components/participant-dot';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import { textMediumLineHeight } from 'styles/global_defaults/fonts';


const participantDotStyles = css`
  line-height: ${textMediumLineHeight}px;
`;

type ParticipantDotProps = {
  role: MentoringProgramRole;
  alias: string;
  className?: string;
};

const ParticipantDotAlias = ({
  role,
  alias,
  className,
}: ParticipantDotProps) => (
  <div
    css={participantDotStyles}
    className={`mentee-status d-flex align-items-center ${className}`}
  >
    <ParticipantDot role={role} className='mr-1' />
    <div className='status-text semi-bold gray-2 align-items-center justify-content-center'>
      {alias}
    </div>
  </div>
);

export default ParticipantDotAlias;
